export const withdrawConfirmation = {
	modal: {
		title: "Confirmación de solicitud de retiro",
		message:
			"Para confirmar el retiro, ingrese el código de aprobación enviado al medio de confirmación configurado del place.",
		codeInput: { label: "Código", placeholder: "Ingrese aquí el código de confirmación" },
		resendCodeBtnLabel: "No recibí mi código",
	},
	form: {
		errors: {
			onlyNumbers: "El código debe contener solo números",
			minLength: "El código debe contener 6 dígitos",
		},
		submit: {
			success: "Solicitud aprobada con éxito",
			error: "Código inválido o expirado",
		},
	},
	resendConfirmationSuccessfully: "Código reenviado con éxito",
	notification:
		"Su solicitud fue procesada con éxito, pero necesita ser confirmada con el código enviado al medio de confirmación configurado para el place.",
};
